export const paymentStatus = {
  PA: "Online",
  FA: "Failed",
  PD: "Pending",
  PS: "Offline",
};
